import React, { useState } from "react";
import './../styles/MemberDashboard.css';
import '../styles/components/Collapsible.css';

const Collapsible = ({ open = false, title, children }) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleFilterOpening = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="collapsible-card">
      <div className="collapsible-header">
        <h6 className="collapsible-title">{title}</h6>
        <button type="button" onClick={handleFilterOpening}>
            {isOpen ? "▲" : "▼"}
        </button>
      </div>
      {isOpen && <div className="collapsible-content">{children}</div>}
    </div>
  );
};

export default Collapsible;
